<template>
  <v-card class="rounded-lg overflow-hidden" flat>
    <v-img
      v-intersect="onIntersect"
      aspect-ratio="16/9"
      class="mb-16"
      src="/media/profile/terminal_profile_bg.webp"
      width="100%"
    >
      <template v-slot:default>
        <div class="profile-img-wrapper">
          <div class="img-holder">
            <img :src="userImage" alt="" />
          </div>
        </div>
      </template>
    </v-img>

    <div>
      <v-card-title>{{ user.name + " " + user.lastName }}</v-card-title>
      <v-card-subtitle class="font-size-h1">{{
        $t("profileView.unknown")
      }}</v-card-subtitle>
    </div>

    <v-row class="px-4 pb-4" no-gutters>
      <v-col cols="12" md="6">
        <div class="w-100 d-flex justify-space-between">
          {{ $t("profileView.email") }}:
          <b>{{ user.email || $t("profileView.unknown") }}</b>
        </div>

        <div class="w-100 d-flex justify-space-between mt-2">
          {{ $t("profileView.balance") }}:
          <b
            >{{ persian($options.filters.rial(wallet.balance)) }}
            {{ $t("profileView.currency") }}</b
          >
        </div>

        <div class="w-100 d-flex justify-space-between mt-2">
          {{ $t("profileView.personType") }}:
          <b>{{ user.type | userType }}</b>
        </div>
      </v-col>

      <v-col class="d-none d-md-block" cols="12" md="6" />

      <v-col cols="12">
        <v-divider />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <widget-2 class="fill-height" />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <panel-info-profile />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Widget2 from "../profile-comp-1/Widget2.vue";
import PanelInfoProfile from "./panelInfoProfile";
import i18n from "@/i18n";

export default {
  name: "profileView",
  i18n,
  props: {
    intersect: {
      type: Boolean,
      default: true,
    },
  },
  components: { PanelInfoProfile, Widget2 },
  data: () => ({
    isIntersecting: true,
  }),
  computed: {
    userImage() {
      return !!this.user?.image
        ? `"${this.$coreApi}/storage/"` + this.user.image
        : "/media/user_avatar.jpeg";
    },
  },
  watch: {
    isIntersecting(val) {
      this.$emit("update:intersect", val);
    },
  },
  methods: {
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-image {
  overflow: visible;
}

.profile-img-wrapper {
  width: 25%;
  aspect-ratio: 1;
  position: relative;

  .img-holder {
    border-radius: 50%;
    position: absolute;
    top: 35%;
    right: 15%;
    width: 100%;
    height: 100%;
    background: white;
    border: solid 2px white;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      max-width: 100%;
      object-fit: contain;
    }
  }
}
</style>
